import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.address.index'),
        name: 'address.index',
        component: () =>
            import(
                /* webpackChunkName: "addresses" */ '@/views/addresses/Index.vue'
            ),
        props: true,
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.tc('resources.address.name', 2),
                    to: { name: 'address.index' },
                    disable: false,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.address.create'),
        name: 'address.create',
        component: () =>
            import(
                /* webpackChunkName: "addresses" */ '@/views/addresses/Create.vue'
            ),
        props: true,
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.tc('resources.address.name', 2),
                    to: { name: 'address.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.create'),
                    to: { name: 'address.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.address.edit') + '/:id',
        name: 'address.edit',
        component: () =>
            import(
                /* webpackChunkName: "addresses" */ '@/views/addresses/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.tc('resources.address.name', 2),
                    to: { name: 'address.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.edit'),
                    to: { name: 'address.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
